/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

init();
/* eslint-disable */
function init(opts) {
  const config = {
    dom: {
      qtyAlert: "qtyAlert",
      qtyText: "js-low-stock-alert-quantity",
      inTheDetails: "inthedetails",
      detailsContent: "detailsContent",
      productWrapper: "Product__InfoWrapper",
      productLeft: "Product__Left",
    },
    cls: {
      show: "show",
      hidden: "hide",
    },
  };

  const c = _.extend(config, opts);

  _.addEvent({
    id: "main",
    event: "variant:changed",
    fn: (e) => {
      checkQtyMsg(e);
    },
  });

  function checkQtyMsg(e) {
    const variant = e.detail.variant;

    const $qtyAlertWrapper = document.getElementById(`${c.dom.qtyAlert}`);
    if (!$qtyAlertWrapper) {
      return false;
    }
    const $qtyAlertText = $qtyAlertWrapper.querySelector(`.${c.dom.qtyText}`);
    const varQty = e.detail.variant.inventory_quantity;

    // if the product can oversell, remove the low quantity mesage
    if (variant.inventory_policy === "continue") {
      _.addClass($qtyAlertWrapper, c.cls.hidden);
      _.removeClass($qtyAlertWrapper, c.cls.show);
      return false;
    }

    if (varQty <= 10 && varQty > 0) {
      $qtyAlertText.innerText = varQty;
      _.addClass($qtyAlertWrapper, c.cls.show);
      _.removeClass($qtyAlertWrapper, c.cls.hidden);
    } else {
      _.addClass($qtyAlertWrapper, c.cls.hidden);
      _.removeClass($qtyAlertWrapper, c.cls.show);
    }
  }

  function moveDetails() {
    const $detailsContent = document.getElementById(`${c.dom.detailsContent}`);
    const $productWrapper = document.querySelector(`.${c.dom.productWrapper}`);
    const $productLeft = document.querySelector(`.${c.dom.productLeft}`);

    if (window.innerWidth < 1025) {
      $productWrapper.after($detailsContent);
    } else {
      $productLeft.appendChild($detailsContent);
    }
  }
  _.windowResize(moveDetails);

  function showDetails() {
    const $details = document.getElementById(`${c.dom.inTheDetails}`);
    const $detailsContent = document.getElementById(`${c.dom.detailsContent}`);

    if (!$details) {
      return false;
    }

    $details.style.display = "block";
    $detailsContent.appendChild($details);

    if (window.innerWidth < 1025) {
      moveDetails();
    }
  }
  showDetails();
}

// Leadership Page Accordion
const $detailsAcc = document.getElementById("detailsAcc");
if ($detailsAcc) {
  SDG.accordion({
    dom: {
      id: "detailsAcc",
    },
    reset_on_resize: false,
    open_option: 0,
  }).init();
}

// Adding insurance to the cart (if applicable)
const $purchaseInsurance = document.getElementById("purchaseInsurance");
if ($purchaseInsurance) {
  /**
   * Add insurance product to the cart
   * @param  {number} quantity
   * @return {null} returns null
   */
  function addInsuranceToCart(quantity = 1) {
    const itemId = $purchaseInsurance.dataset.variantId;

    _.ajax({
      type: "POST",
      contentType: "application/json",
      url: `${window.routes.cartAddUrl}.js`,
      data: JSON.stringify({
        quantity: `${quantity}`,
        id: itemId,
      }),
      success: () =>
        setTimeout(() => {
          refreshCart();
        }, 100),
      error: (err) => console.log("error:", err),
    });

    return null;
  }

  function refreshCart() {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );
  }

  document.documentElement.addEventListener("product:added", (event) => {
    if ($purchaseInsurance && $purchaseInsurance.checked) {
      addInsuranceToCart(event.detail.quantity);
    }
  });
}

// Handling insurance modal
if ($purchaseInsurance) {
  const $insuranceModal = document.getElementById("js-insurance-modal");
  const $acceptInsurance = document.getElementById("js-insurance-accepted");
  const $refuseInsurance = document.getElementById("js-insurance-refused");

  const config = {
    showClass: "show",
  };

  $purchaseInsurance.addEventListener("click", function () {
    if ($purchaseInsurance.checked === true) return; // only show modal if customer tries to unselect the checkbox

    $insuranceModal.classList.toggle(config.showClass);
    $acceptInsurance.onclick = function () {
      $purchaseInsurance.checked = true;
      $insuranceModal.classList.toggle(config.showClass);
    };
    $refuseInsurance.onclick = function () {
      $purchaseInsurance.checked = false;
      $insuranceModal.classList.toggle(config.showClass);
    };
  });
}
